module.exports = __webpack_public_path__ + "static/media/IMG_0303.22df8a0d.JPG";